import React from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

const withRedirects = WrappedComponent => {
  return props => {
    const {
      account // via query
    } = props

    const location = useLocation()
    const navigate = useNavigate()

    if (account) {
      if (location.pathname === '/campers' && account.campers.length === 0) {
        navigate('/campers/new', { replace: true })
      }

      if (
        location.pathname === '/emergency_contacts' &&
        account.emergencyContacts.length === 0
      ) {
        navigate('/emergency_contacts/new', { replace: true })
      }
    }

    return <WrappedComponent {...props} />
  }
}

export default withRedirects
